import { LitEntity, html } from '../utility/lit-entity';
import { BnModalMixin } from '../common/bn-modal-mixin';
import './actions/change-user-role';

class ChangeUserRoleModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'change-user-role-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#change-user-role-modal {
          --modal-min-width: 55%;
          --modal-min-height: auto;
          --modal-body-background: var(--gray-20);
        }
      </style>
      <h3 slot="title">Select User Role</h3>
      <change-user-role .href="${this.href}" @role-set="${this._onSetRole}"></change-user-role>
    `;
  }

  _onSetRole(e) {
    this.dispatchEvent(new CustomEvent('user-role-changed', { detail: e.detail, bubbles: true, composed: true }));
    this.close();
  }
}

window.customElements.define('change-user-role-modal', ChangeUserRoleModal);
